/**
 * LES REFUS DU MODULE ANALYSE, en mots — lot 97, 18/09/2026.
 *
 * Une fonction et non une table complète : les écrans d'analyse ne
 * rencontrent qu'une poignée de refus, et l'API donne presque toujours sa
 * propre phrase (`Resultat.message`), qui passe avant celle-ci.
 */

import type { EchecApi } from './api.js';

export function messageRefusAnalyse(cause: EchecApi): string {
  switch (cause) {
    case 'acces':
      return 'Votre accès a été refusé. Reconnectez-vous.';
    case 'introuvable':
      return 'Cette pièce n’est plus ouverte : elle a peut-être été réglée. Relisez les données Pennylane.';
    case 'injoignable':
      return 'Stafa ne répond pas. Vérifiez votre connexion et réessayez.';
    case 'invalide':
      return 'La saisie est incomplète ou hors des valeurs attendues.';
    case 'service':
      return 'Stafa a refusé la demande sans pouvoir dire pourquoi. Réessayez, puis signalez-le.';
    default:
      return 'La demande a été refusée.';
  }
}
